// format-currency.pipe.ts
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
   name: 'formatCurrency',
   pure: true, // default: ensures the pipe only recalculates when input changes
   standalone: false,
})
export class FormatCurrencyPipe implements PipeTransform {
   transform(value: number, decimals = 2): string {
      if (value == null || isNaN(Number(value))) return ''

      const fractionDigits = Math.max(0, Math.floor(Number(decimals)))

      return new Intl.NumberFormat('en-US', {
         style: 'currency',
         currency: 'USD',
         minimumFractionDigits: fractionDigits,
         maximumFractionDigits: fractionDigits,
      }).format(value)
   }
}
